import { Controller } from "stimulus";

export default class extends Controller {

  static get targets() {
    return [
        'item',
        'answer'
    ];
  }

  toggle(e) {
    const toggle = e.currentTarget;
    const item = this.itemTargets.find(target => target.contains(toggle));
    const answer = this.answerTargets.find(target => item.contains(target));

    if (answer) {
      answer.style.setProperty('--height', `${answer.scrollHeight}px`);
    }

    toggle.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded') !== 'true');
    item.classList.toggle('is-open');
  }
};
